<template>
  <div id="app">
    <Header :message="headerMessage" ></Header>
    <router-view/>
    <Footer @sendMessage="handleFooterClick" ></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return{
      headerMessage: ''  // 用来存储 Footer 传递过来的数据
    }
  },
  methods: {
    // 处理 Footer 传递过来的数据
    handleFooterClick(message) {
      this.headerMessage = message;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue